var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 612 612"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M386 137.7h46V57.6c-7.9-1.1-35.2-3.5-67-3.5-66.3 0-111.8 41.7-111.8 118.4V243H180v89.6h73.2V558H343V332.6h70.2l11.2-89.6H343v-61.7c0-25.9 6.9-43.6 43-43.6z"
  })));
}

export default SvgFacebook;